<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span *ngIf="!zone_macId">Add Zone Machine Master</span>
                <span *ngIf="zone_macId">Update Zone Machine Master</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="zoneMachineForm" (submit)="createZoneMachine()">
                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label class="form-label">Circle *</label>
                                    <mat-select (selectionChange)="getCircleZone($event.value)" placeholder="Circle"
                                        [disabled]="diss_circle_city" formControlName="circle_id"
                                        (click)="setSearchValue('circle')">
                                        <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'circle')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="circleSearch">
                                        <mat-option>All</mat-option>
                                        <mat-option [value]="cir.id" *ngFor="let cir of circles">{{cir.name}}
                                        </mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.circle_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.circle_id.errors.required">Circle is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label class="form-label">Zone *</label>
                                    <mat-select placeholder="Zone" [disabled]="diss_circle_city"
                                        formControlName="zone_id" (click)="setSearchValue('zone')">
                                        <input class="mySearchInput" #zoneSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'zones')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="zoneSearch">
                                        <mat-option [value]="zone.id" *ngFor="let zone of zones">
                                            {{zone.zone_name}}
                                        </mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.zone_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.zone_id.errors.required">Zone is required</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label class="form-label">Machine *</label>
                                    <mat-select placeholder="Select Machine" (click)="setSearchValue('machine')"
                                        formControlName="machine_id">
                                        <input class="mySearchInput" #machineSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'machine')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="machineSearch">
                                        <mat-option [value]="machine.id" *ngFor="let machine of allscanmachine">
                                            {{machine.name}}
                                        </mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.machine_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.machine_id.errors.required">Machine is required</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <button type="button" class="btn btn-success btn-sm book_days" (click)="openDateRange()">
                            Booking Days <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                        <br><br>
                        <div class="col-md-12" *ngIf="daterangeShow">
                            <div class="row align-items-center">
                                <div class="col-md-6 mt-2">
                                    <label class="form-label">Select a Date Range:</label>
                                    <mat-form-field appearance="fill">
                                        <mat-label>Start date - End date</mat-label>
                                        <mat-date-range-input [rangePicker]="picker"
                                            formGroupName="zoneMachineDateRange">
                                            <input matStartDate #dateRangeStart placeholder="Start date"
                                                formControlName='from_date'>
                                            <input matEndDate #dateRangeEnd placeholder="End date"
                                                formControlName='to_date'
                                                (dateChange)="dateRangeChange(dateRangeStart.value, dateRangeEnd.value)">
                                        </mat-date-range-input>
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-date-range-picker #picker></mat-date-range-picker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <button type="button" class="btn add_qty float-right" *ngIf="openDayListbtn"
                                        (click)="addQuantity()">
                                        Days List <i class="fa fa-plus" aria-hidden="true"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive text-nowrap">
                            <table class="table table-striped">
                                <tbody>
                                    <div class="col-sm-12" formArrayName="bookingDays" style="display: contents;">
                                        <tr *ngFor="let quantity of bookingDays().controls; let i=index"
                                            [formGroupName]="i">
                                            <td class="td1">
                                                <div class="col">
                                                    <label class="form-label">Days List:</label>
                                                    <mat-select placeholder="Select Days" formControlName="days_list">
                                                        <mat-option *ngFor="let days of this.underDateRangeDays"
                                                            [value]="days.value">
                                                            {{days.name}}
                                                        </mat-option>
                                                    </mat-select>
                                                </div>
                                            </td>
                                            <td class="td1">
                                                <div class="col">
                                                    <label class="form-label">No.of Booking:</label>
                                                    <input type="text" class="form-control" placeholder="No.of Booking"
                                                        formControlName="no_of_booking" />
                                                </div>
                                            </td>
                                            <td class="td1">
                                                <div class="col">
                                                    <label class="form-label">From Time:</label>
                                                    <input type="time" class="form-control" placeholder="From Time"
                                                        formControlName="from_time" />
                                                </div>
                                            </td>
                                            <td class="td1">
                                                <div class="col">
                                                    <label class="form-label">To Time:</label>
                                                    <input type="time" class="form-control" placeholder="To Time"
                                                        formControlName="to_time" />
                                                </div>
                                            </td>
                                            <td class="td1">
                                                <button class="btn btn-danger mt-5" mwlConfirmationPopover
                                                    [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage"
                                                    [confirmText]="confirmText" [cancelText]="cancelText"
                                                    [placement]="placement" (confirm)="removeQuantity(i)"
                                                    (cancel)="cancelClicked = true" confirmButtonType="danger"
                                                    cancelButtonType="outline-secondary"
                                                    (click)="confirmClicked = false; cancelClicked = false"
                                                    [appendToBody]="true">
                                                    Remove
                                                </button>
                                            </td>
                                        </tr>
                                    </div>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary add_qty"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span *ngIf="!zone_macId">Create Zone Machine</span>
                        <span *ngIf="zone_macId">Update Zone Machine</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>